// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3ReVO","location":"Header_location__2DbFX"};